const $buttons = $('.review__button');

$buttons.on('click', (e) => {
	const $block = $(e.currentTarget).closest('.review');
	const $text = $block.find('.review__additional');

	if ($block.hasClass('is-show')) {
		$block.removeClass('is-show');
		$text.slideUp(500);

		if ($block.next().hasClass('review')) {
			const $reviewTop = $block.next().offset().top;
			$('html, body').animate({scrollTop: $reviewTop - $text.height() - 42}, 500);
		}
	} else {
		$block.addClass('is-show');
		$text.slideDown(500);
	}
});
